import React from 'react'
import { Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import TitleWithText from './TitleWithText'

const ObservationTracking = ({ items = {} }) => {
  const { t } = useTranslation()

  const { teethEruption, spacingCrowding, oralHealthImprovements, biteChange, other } = items || {}

  const normalizeCheckboxValue = value => {
    if (!value) {
      return { isChecked: false, note: '' }
    }

    if (typeof value === 'string') {
      return { isChecked: true, note: value }
    }

    if (typeof value === 'object') {
      return { isChecked: !!value.isChecked, note: value.note || '' }
    }

    return { isChecked: false, note: '' }
  }

  const normalizedItems = {
    teethEruption: normalizeCheckboxValue(teethEruption),
    spacingCrowding: normalizeCheckboxValue(spacingCrowding),
    oralHealthImprovements: normalizeCheckboxValue(oralHealthImprovements),
    biteChange: normalizeCheckboxValue(biteChange),
    other: normalizeCheckboxValue(other)
  }

  if (!Object.values(normalizedItems).some(value => value.isChecked)) {
    return null
  }

  return (
    <Grid container direction="column" spacing={2}>
      {normalizedItems.teethEruption.isChecked && (
        <Grid item>
          <TitleWithText
            title={`${t('dialogs.hiPatientGuidelinesViewer.categories.observationTracking.teethEruption')}:`}
            text={normalizedItems.teethEruption.note}
          />
        </Grid>
      )}
      {normalizedItems.spacingCrowding.isChecked && (
        <Grid item>
          <TitleWithText
            title={`${t('dialogs.hiPatientGuidelinesViewer.categories.observationTracking.spacingCrowding')}:`}
            text={normalizedItems.spacingCrowding.note}
          />
        </Grid>
      )}
      {normalizedItems.oralHealthImprovements.isChecked && (
        <Grid item>
          <TitleWithText
            title={`${t('dialogs.hiPatientGuidelinesViewer.categories.observationTracking.oralHealthImprovements')}:`}
            text={normalizedItems.oralHealthImprovements.note}
          />
        </Grid>
      )}
      {normalizedItems.biteChange.isChecked && (
        <Grid item>
          <TitleWithText
            title={`${t('dialogs.hiPatientGuidelinesViewer.categories.observationTracking.biteChange')}:`}
            text={normalizedItems.biteChange.note}
          />
        </Grid>
      )}
      {normalizedItems.other.isChecked && (
        <Grid item>
          <TitleWithText
            title={`${t('dialogs.hiPatientGuidelinesViewer.categories.observationTracking.other')}:`}
            text={normalizedItems.other.note}
          />
        </Grid>
      )}
    </Grid>
  )
}

export default ObservationTracking
